import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ListService } from '@fry/lib/list';
import { BookingItemsSearch, BookingItemsStore } from '@fry/booking/lib/booking-items';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { SecurityService } from '@fry/lib/security';
import { of } from 'rxjs';


@Component({
    selector: 'eas-booking-item-list',
    templateUrl: './booking-item-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingItemListComponent implements OnInit, OnDestroy {

  private readonly security = inject(SecurityService);

  public items = this.list.items;
  public actions: EASLinkAction[] = [
    {
      type: 'link',
      label: $localize `New booking item`,
      condition: () => {
        return this.security.hasPotentialPermission('bookingItems.create');
      },
      link: of(['add']),
      color: 'primary',
    }
  ];

  constructor(
    private store: BookingItemsStore,
    private search: BookingItemsSearch,
    private list: ListService
  ) { }

  ngOnInit() {
    this.list.setupWith(this.store, this.search, undefined, {}, 'booking-items').subscribe();
  }

  ngOnDestroy() {
  }

}
